import {showValidationErrorsModal} from "@utils/modal-manager";
import ScrollableTextBoxBlock from "@components/common/form-blocks/scrollable/text-box-block";
import {ValidateStep5Data} from "@validators/fast-food-delivery-insurance-form/step5-validator";
import {
   CommonAdditionalDriverForm
} from "@components/common/sub-components/insurance-form-parts/additional-driver-form/common-additional-driver-form";
import {WizardStepButtonsBlock} from "@components/common/form-blocks/other/wizard-step-buttons-block";
import {TermsAgreementBlock} from "@components/common/form-blocks/other/terms-agreement-block";
import {isEditableMode, useFormMode} from "@contexts/FormModeContext";

export default function IF_Step5(
   {
      data,
      handlers, setCurrentStep,
      addAdditionalDriver,
      handleAdditionalDiverPropChange,
      removeAdditionalDiverByIndex,
      handleAdditionalDriverAccidentPropChange,
      addAdditionalDriverAccident,
      removeAdditionalDriverAccident,
      onSubmit,
      formRef,
      handleAdditionalDriverConvictionPropChange,
      addAdditionalDriverConviction,
      removeAdditionalDriverConviction,
   }) {
   
   const {mode} = useFormMode();
   
   const STEP = 5;
   
   const onPrevBtnClick = (event) => {
      setCurrentStep(STEP - 1);
   }
   
   const onNextBtnClick = async (event) => {
      
      let validationResult = ValidateStep5Data(data);
      
      if (validationResult.length) {
         
         showValidationErrorsModal({
            validationResult: validationResult
         });
         
         
      } else {
         onSubmit();
      }
      
      
   }
   
   return (
      <div className={`if-step-${STEP}`}>
         
         
            
            <CommonAdditionalDriverForm
               sectionHeading="Additional Drivers"
               data={data}
               
               buttonGroupOnChange={handlers.onControlChange}
               buttonGroupLabel="Would you like to add an additional driver?"
               
               addAdditionalDriver={addAdditionalDriver}
               handleAdditionalDiverPropChange={handleAdditionalDiverPropChange}
               removeAdditionalDiverByIndex={removeAdditionalDiverByIndex}
               
               handleAdditionalDriverAccidentPropChange={handleAdditionalDriverAccidentPropChange}
               addAdditionalDriverAccident={addAdditionalDriverAccident}
               removeAdditionalDriverAccident={removeAdditionalDriverAccident}
               
               handleAdditionalDriverConvictionPropChange={handleAdditionalDriverConvictionPropChange}
               addAdditionalDriverConviction={addAdditionalDriverConviction}
               removeAdditionalDriverConviction={removeAdditionalDriverConviction}
            />
            
            {/* Additional comments */}
         
         <div className="row">
            
            <ScrollableTextBoxBlock
               containerCssClass="col-12 py-3 "
               labelText="Additional comments"
               required={false}
               controlName="addAdditionalComments"
               value={data.addAdditionalComments}
               onChange={handlers.onControlChange}
               inputAttrs={{
                  maxLength: 1024,
                  rows: 5
               }}
               asTextArea={true}
            />
         
         </div>
         
         
         {isEditableMode(mode) && (
            <TermsAgreementBlock
               controlName={"termsAgreement"}
               controlIdPrefix={"termsAgreement-"}
               required={true}
               onChange={handlers.onControlChange}
               selectedValue={data.termsAgreement}
               labelText={"Terms agreement"}
               isHidden={false}
            />
         
         )}
         
         
         
         <WizardStepButtonsBlock
            prevBtnText={"Previous"}
            onPrevBtnClick={onPrevBtnClick}
            nextBtnText={"Submit"}
            onNextBtnClick={onNextBtnClick}
            nextBtnIconClass={"fa fa-fw fa-save me-2"}
            nextBtnIconPosition={"left"}
            isNextBtnDisabled={data.termsAgreement !== 'Yes'}
         />
      
      
      </div>
   );
}